module.exports = __webpack_public_path__ + "static/media/LEAF-web-large-wheretobuy.9579a8b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Leaf/LEAF-web-large-wheretobuy.jpg
// module id = 678
// module chunks = 0